module.exports = __webpack_public_path__ + "static/media/logo.4d50dc58.png";